@if (url!== '/multicompany')  {
  <div class="{{ theme }} {{ className }}">
    <app-header
      (closeMenuEcosystemEmitter)="closeMenuEcosystem()"
      (closeMenuEmitter)="closeMenu($event)"
      (closeMenuMobileEmitter)="closeMenuMobile()"
      (closeMenuUserEmitter)="closeMenuUser()"
      (closeSessionEmitter)="closeSession()"
      (emitClearFilter)="clearSearch($event)"
      (emitInputFilter)="search($event)"
      (openMenuEcosystemEmitter)="openMenuEcosystem()"
      (openMenuEmitter)="openMenu($event)"
      (openMenuMobileEmitter)="openMenuMobile()"
      (openMenuUserEmitter)="openMenuUser()"
      (openWindowEmitter)="openWindow($event.url, $event.target)"
      [className]="className"
      [isCompanyAdmin]="isCompanyAdmin"
      [isDesktop]="isDesktop"
      [searchValue]="searchValue"
      [showMenuEcosystem]="showMenuEcosystem"
      [showMenuUser]="showMenuUser"
      [showMenu]="showMenu"
      [theme]="theme"
      [userAvatar]="userAvatar"
      [userName]="userName"
      [width]="width"
      class="{{ theme }} {{ className }}__header"></app-header>
    <mat-sidenav-container
      *ngIf="!isLoading"
      [hasBackdrop]="!isDesktop"
      class="{{ theme }} {{ className }}__container">
      <mat-sidenav
        #sidenav
        [class.main-layout__menu--active]="showMenu"
        [mode]="isDesktop ? 'push' : 'over'"
        [style.bottom]="isDesktop ? '0' : 'auto'"
        [style.top]="isDesktop ? '46px' : '46px'"
        class="{{ theme }} {{ className }}__menu"
        disableClose
        fixedInViewport="true"
        fixedTopGap="46">
        <app-menu
          (closeMenuEmitter)="closeMenu($event)"
          (closeSessionEmitter)="closeSession()"
          [isAdmin]="isAdmin"
          [isDesktop]="isDesktop"
          [dataCategories]="dataCategories"
          [showMenu]="showMenu"
          [theme]="theme"
          [width]="width"></app-menu>
      </mat-sidenav>
      <mat-sidenav-content
        [class.main-layout__content--active]="showMenu"
        [class.main-layout__content--compact]="url?.includes('/admin')"
        class="{{ theme }} {{ className }}__content">
        <div
          (click)="showMenuEcosystem = false; showMenu = false; showMenuUser = false"
          *ngIf="showMenuEcosystem || showMenuUser"
          class="{{ theme }} {{ className }}__overlay"></div>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}@else{
  <router-outlet></router-outlet>
}